import React, {useEffect} from 'react';
import {useDispatch, useSelector} from "react-redux";

import css from './ProductGroupsListComponent.module.css';
import {productGroupsActions} from "../../../store/slices/settings-slices";
import ProductGroupComponent from "../ProductGroupComponent/ProductGroupComponent";


const ProductGroupsListComponent = () => {
    const dispatch = useDispatch();
    const {productGroups, trigger} = useSelector(store => store.productGroups);

    useEffect(() => {
        dispatch(productGroupsActions.getAllProductGroups());
    }, [trigger]);


    return (
        <section className={css.wrap}>
            {productGroups && productGroups.map((obj) => <ProductGroupComponent
            key={obj.id}
            productGroups={obj}
            />)
            }
        </section>
    );
};

export default React.memo(ProductGroupsListComponent);